// extracted by mini-css-extract-plugin
module.exports = {"root":"StreamVideoPlayer_root__FrUl2","videoContainer":"StreamVideoPlayer_videoContainer__ZbwXl","videoPlayer":"StreamVideoPlayer_videoPlayer___tSF_"};